import React from 'react';
import Typography from '@material-ui/core/Typography';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import {Guid} from '../../ext/lib/types';
import AdStatusChip from './AdStatusChip';
import AdminAdActions from './AdminAdActions';
import {JsonAdSummary} from '../../ext/lib/types';
import CcoaString from '../../ext/types/CcoaString';
import {APIError, UnsafeAPIResponse} from '../../hooks/useApi';
import useApi from '../../hooks/useApi';
import {displayJsonDate} from '../../ext/lib/temporal';
import {displayAdCost, invoiceNumber} from '../../ext/billing';
import * as R from 'ramda';

type Props = {apiToken: string}

const ListAds: React.FC<Props> = ({apiToken}) => {
  const response: UnsafeAPIResponse<{ ads: JsonAdSummary[] }> = useApi(apiToken, '/api/v1/requests');

  const adRow: (_: JsonAdSummary) => React.ReactNode =
    (ad: JsonAdSummary) =>
      <TableRow key={ad.adKey}>
        <TableCell><AdStatusChip ad={ad} /></TableCell>
        <TableCell style={{textAlign: 'center'}}>
          {displayJsonDate(ad.firstDate)}<br />to<br />{displayJsonDate(ad.lastDate)}
        </TableCell>
        <TableCell style={{overflowWrap: 'anywhere'}}>{ad.organization}</TableCell>
        <TableCell style={{overflowWrap: 'anywhere'}}>{ad.adName}</TableCell>
        <TableCell>
          <div>{ad.userFirstName} {ad.userLastName}</div>
          <div>{ad.contactPhoneNum}</div>
          <div>{ad.userEmailAddress}</div>
        </TableCell>
        <TableCell>{invoiceNumber(ad)}</TableCell>
        <TableCell>{CcoaString.format(ad.rechargeNumber)}</TableCell>
        <TableCell>{ad.slideCount}</TableCell>
        <TableCell align="right">{displayAdCost(ad)}</TableCell>
        <TableCell style={{overflowWrap: 'anywhere'}}>{ad.comments}</TableCell>
        <TableCell>
          <AdminAdActions adKey={ad.adKey as Guid}/>
        </TableCell>
      </TableRow>;

  if (response === undefined) {
    return <div>Loading...</div>;
  } else if (R.pathEq(['ads', 'length'], 0, response)) {
    return <Typography variant="h1">No ads have been requested.</Typography>;
  } else if (R.pathEq(['@@type'], 'Error', response)) {
    console.error((response as APIError).message);
    return <div className="alert error">An error occurred while fetching ads. Try again or contact support</div>;
  } else {
    return <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell>Broadcast</TableCell>
            <TableCell>Dept</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Contact</TableCell>{/* Name, Phone, Email */}
            <TableCell>Invoice&nbsp;#</TableCell>
            <TableCell>Recharge&nbsp;#</TableCell>
            <TableCell>Slides</TableCell>
            <TableCell>Fee</TableCell>{}
            <TableCell>Comments</TableCell>
            <TableCell>{/*Actions*/}</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {R.map(adRow, (response as {ads: JsonAdSummary[]}).ads)}
        </TableBody>
      </Table>
    </TableContainer>;
  }
};
export default ListAds;
